import React from 'react'
import { connect } from 'react-redux'
import { Typography, CircularProgress, Button, Grid, Collapse, Select, MenuItem } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import _ from 'lodash'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import dataProvider from '../../../../../providers'
import { getResource } from '../../../../../config/resources'
import { GET_LIST, showNotification, UPDATE } from 'react-admin'
import { ConfirmationDialog } from '../../../../../components'
import AppTriggerOption from './apptriggeroption'

const guestModeStates = [
  { state: 'guest', name: 'On' },
  { state: 'mandatory', name: 'Off' },
]

const appTriggersDescriptions = {
  matchThirdNavigation: { title: 'Third search (any match details)', description: 'The third time when exploring the details of any match' },
  newsThirdNavigation: { title: 'Third any news opening', description: 'The third time when opening any news (regardless of the way to access it)' },
  playerOrTeamThirdNavigation: { title: 'Third search (any player and/or club)', description: 'The third time when exploring ANY Player AND/OR Club details' },
  statsTabThirdNavigation: { title: 'Third stats tab opening from navbar', description: 'The third time when opening the stats tab from navbar' },
  triggersResetTime: {
    title: 'Days to reset counter (since the first modal showed up)',
    description: 'Allow to modify the reset time value (not applicable for first and second triggers)',
  },
  twoContentsShared: {
    title: 'Every two shared contents',
    description: 'Every time that two contents are shared (2nd, 4th, 6th time, and so on when the user clicks on share content: Videos, News)',
  },
  userFourthAccess: {
    title: 'Fourth app opening (per installation)',
    description: 'Open the app for the fourth time (3rd from the first opening) (Once per installation)',
  },
  userSecondAccess: {
    title: 'Second app opening (per installation)',
    description: 'Open the app for the second time (2nd from the first opening) (Once per installation)',
  },
  videoThirdNavigation: { title: 'Third any video opening', description: 'The third time when opening any video (regardless of the way to access it)' },
}

const styles = (theme) => ({
  modalTriggersSubtitlesContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginLeft: '24px',
    maxWidth: '440px',
    marginTop: '24px',
    [theme.breakpoints.down('md')]: {
      maxWidth: '356px',
    },
  },
})

class GuestMode extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isModalOpen: false,
      openList: false,
      loading: false,
      fetching: false,
      guestMode: null,
    }
    this.handleModalOpen = this.handleModalOpen.bind(this)
    this.handleModalClose = this.handleModalClose.bind(this)
    this.handleSaveData = this.handleSaveData.bind(this)
    this.handleGuestMode = this.handleGuestMode.bind(this)
  }

  componentDidMount() {
    this.getGuestmode()
  }

  handleModalOpen() {
    this.setState({
      isModalOpen: true,
    })
  }

  handleModalClose() {
    this.getGuestmode()
    this.setState({
      isModalOpen: false,
    })
  }

  handleGuestMode(event, section, key) {
    const copyGuestMode = { ...this.state.guestMode }
    if (section === 'loginMode') {
      copyGuestMode.contentJson.loginMode[key] = event.target.value
    } else if (section === 'appTriggers') {
      if (key === 'triggersResetTime') {
        copyGuestMode.contentJson.appTriggers[key] = Number(event.target.value, 10)
      } else {
        copyGuestMode.contentJson.appTriggers[key] = event.target.checked
      }
    }
    this.setState({ guestMode: copyGuestMode })
  }

  handleSaveData() {
    this.setState({ fetching: true })
    let data = { ...this.state.guestMode }
    data.contentJson = JSON.stringify(data.contentJson)
    dataProvider(UPDATE, getResource('transversal', 'globaldatas'), {
      id: this.state.guestMode.id,
      data: data,
    })
      .then(({ data }) => {
        this.setState({ fetching: false, guestMode: data, isModalOpen: false })
        this.props.showNotification('Guest mode state updated', 'success')
      })
      .catch((error) => {
        this.setState({ error: true, fetching: false, isModalOpen: false })
        this.props.showNotification(error.message, 'error')
      })
  }

  getGuestmode = () => {
    this.setState({ loading: true })
    dataProvider(GET_LIST, getResource('transversal', 'globaldatas'), {
      sort: {
        field: 'id',
        order: 'DESC',
      },
      filter: {
        name: 'APP_CONFIG',
      },
      pagination: { page: 1, perPage: 20 },
    }).then((res) => {
      this.setState({ guestMode: res.data[0], loading: false })
    })
  }

  handleClick = () => {
    this.setState({
      openList: !this.state.openList,
    })
  }
  render() {
    return (
      <>
        <div style={{ margin: '29px' }}>
          {this.state.loading ? (
            <div style={{ display: 'flex' }}>
              <Typography component="h2" variant="h2" style={{ marginBottom: '16px', marginRight: '16px' }}>
                Loading Guest mode
              </Typography>
              <CircularProgress size={24} />
            </div>
          ) : (
            <div style={{ display: 'flex', alignItems: 'flex-start' }} onClick={() => this.handleClick()}>
              <Typography component="h2" variant="h2" style={{ marginBottom: '16px' }}>
                Guest Mode
              </Typography>
              <div style={{ marginLeft: '16px' }}>{this.state.openList ? <ExpandLess /> : <ExpandMore />}</div>
            </div>
          )}
          {this.state.guestMode && this.state.openList && (
            <Collapse in={this.state.openList} timeout={350}>
              <Grid item xs={12} lg={8}>
                <div style={{ opacity: this.state.loading ? 0 : 1, transition: 'opacity 350ms' }}>
                  <Grid item xs={12} lg={8}>
                    <Typography>IOS:</Typography>
                    <Select
                      value={this.state.guestMode?.contentJson?.loginMode?.ios}
                      onChange={(event) => this.handleGuestMode(event, 'loginMode', 'ios')}
                      fullWidth
                    >
                      {_.map(guestModeStates, (item) => (
                        <MenuItem key={item.state} value={item.state}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                  <Grid item xs={12} lg={8}>
                    <Typography>Android:</Typography>
                    <Select
                      value={this.state.guestMode?.contentJson?.loginMode?.android}
                      onChange={(event) => this.handleGuestMode(event, 'loginMode', 'android')}
                      fullWidth
                    >
                      {_.map(guestModeStates, (item) => (
                        <MenuItem key={item.state} value={item.state}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                  <Grid item xs={12} md={10} xl={10}>
                    <div style={{ opacity: this.state.loading ? 0 : 1, transition: 'opacity 350ms' }}>
                      {this.state.guestMode?.contentJson?.appTriggers && (
                        <>
                          <Typography variant="title">Triggers to register modal show up</Typography>
                          <div className={this.props.classes.modalTriggersSubtitlesContainer} style={{}}>
                            <Typography variant="button">Events</Typography>
                            <Typography variant="button">Enabled</Typography>
                          </div>
                          <Grid item xs={12}>
                            {Object.keys(this.state.guestMode?.contentJson?.appTriggers)
                              ?.filter((option) => option !== 'triggersResetTime')
                              ?.map((option, index) => (
                                <AppTriggerOption
                                  key={option}
                                  index={index + 1}
                                  checked={this.state.guestMode.contentJson.appTriggers[option]}
                                  option={option}
                                  title={appTriggersDescriptions[option].title}
                                  description={appTriggersDescriptions[option].description}
                                  handleGuestMode={this.handleGuestMode}
                                />
                              ))}
                          </Grid>
                          <Grid item xs={12}>
                            {Object.keys(this.state.guestMode.contentJson.appTriggers)
                              .filter((option) => option === 'triggersResetTime')
                              .map((option) => (
                                <AppTriggerOption
                                  key={option}
                                  index={Object.keys(this.state.guestMode.contentJson.appTriggers).length}
                                  checked={this.state.guestMode.contentJson.appTriggers[option]}
                                  option={option}
                                  title={appTriggersDescriptions[option].title}
                                  description={appTriggersDescriptions[option].description}
                                  handleGuestMode={this.handleGuestMode}
                                />
                              ))}
                          </Grid>
                        </>
                      )}
                    </div>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      size="large"
                      disabled={this.state.loading || this.state.fetching}
                      onClick={() => this.handleModalOpen()}
                    >
                      {this.state.fetching ? 'Saving...' : 'Save'}
                    </Button>
                  </Grid>
                </div>
              </Grid>
            </Collapse>
          )}
        </div>
        <ConfirmationDialog
          title="Descargo de responsabilidad:"
          open={this.state.isModalOpen}
          maxWidth="sm"
          onCancel={this.handleModalClose}
          onSuccess={this.handleSaveData}
          isFetching={this.state.fetching}
        >
          <Typography>
            Esto modifica y permite habilitar o no el flujo de GUEST en toda la App Oficial.  IMPORTANTE antes de hacer ningún cambio confirma con el equipo de
            Producto de LALIGA.
          </Typography>
        </ConfirmationDialog>
      </>
    )
  }
}

const enhance = connect(null, {
  showNotification,
})

export default enhance(withStyles(styles)(GuestMode))
